/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Hủy"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Bạn đã có lý do kinh doanh hợp lý để truy cập dữ liệu khách hàng"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Hoạt động tải xuống của bạn sẽ được ghi lại và theo dõi nhằm mục đích tuân thủ bảo mật"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Bạn có muốn tiếp tục không?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Khi tải xuống, bạn xác nhận rằng:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
